import fun from "@/util/util";
import myApi from "@/util/my-api";
import myConst from "@/util/my-const";
import Axios from "../../../axios"
export default {
    namespaced:true,
    state:{
        btnList:""
    },
    mutations:{
        // 设置按钮列表
        setBtnList(state,map){
            state.btnList = map
            let obj = {}
            map.forEach((value, key) => {
                obj[key] = value;
            });
            localStorage.setItem(myConst.keyBtnList, JSON.stringify(obj));
        },

        //清除按钮
        clearBtnList(state){
            localStorage.removeItem(myConst.keyBtnList);
            state.btnList = ""
        }
    },
    getters:{
        getButton(state){
            let storedData = JSON.parse(localStorage.getItem(myConst.keyBtnList));
            if(fun.isNull(storedData)){return}
            let map = new Map(Object.entries(storedData));
            state.btnList = map
            return state.btnList
        },
    },
    actions:{
        // 获取权限按钮
        getPerButton(context){
            Axios.post(myApi.getBusButtonList,{}).then(res=>{
                if(res.data.code === myConst.code.success){
                    let myMap = new Map()
                    let data = res.data.data
                    if(!fun.isNull(data) && data.length > 0){
                        data.forEach(item=>{
                            myMap.set(item.buttonCode,item.buttonCode)
                        })  
                        context.commit('setBtnList',myMap)
                    }     
                }
            })
        }
    }
}